import { PageHeader } from "@/components/site/shared";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Phone, ShieldCheck, Clock, Camera } from "lucide-react";
import { PHONE, TEL } from "@/lib/config";

const PERKS = [
  { icon: ShieldCheck, t: "Veteran-Owned & Insured" },
  { icon: Camera, t: "Upload photos for accuracy" },
  { icon: Clock, t: "No obligation — free quote" },
];

export default function GetQuote() {
  return (
    <div>
      <PageHeader overline="Free Quote" title="Get a Free Quote"
        subtitle="Tell us about your project and we'll follow up. The more detail and photos you share, the better we can help." />
      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-[1fr_540px] gap-12">
          <div>
            <div className="space-y-4">
              {PERKS.map((p) => (
                <div key={p.t} className="flex items-center gap-3 bg-white border border-gray-100 rounded-2xl p-5 card-shadow">
                  <p.icon className="w-6 h-6 text-[var(--action)]" /><span className="font-semibold text-[var(--navy)]">{p.t}</span>
                </div>
              ))}
            </div>
            <div className="mt-8 bg-[var(--navy)] text-white rounded-2xl p-6">
              <p className="text-white/80">Prefer to talk now?</p>
              <a href={TEL} className="inline-flex items-center gap-2 mt-2 font-head font-bold text-2xl"><Phone className="w-6 h-6 text-[var(--aqua)]" /> {PHONE}</a>
            </div>
          </div>
          <div className="bg-white border border-gray-100 rounded-2xl card-shadow p-6">
            <QuoteForm variant="general" source="quote_form" />
          </div>
        </div>
      </section>
    </div>
  );
}
